"use client";

import { usePathname, useRouter, useSearchParams as useNextSearchParams } from "next/navigation";

export interface NavigateOptions {
  scroll?: boolean;
}

const useSearchParams = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useNextSearchParams();

  const updateSearchParam = (
    keyValues: { key: string; value: string | undefined }[],
    replace = false,
    options?: NavigateOptions,
  ) => {
    const newSearchParams = new URLSearchParams(searchParams);
    keyValues.forEach(({ key, value }) => {
      if (value) {
        newSearchParams.set(key, value);
      } else {
        newSearchParams.delete(key);
      }
    });
    if (replace) {
      router.replace(`${pathname}?${newSearchParams.toString()}`);
    } else {
      router.push(`${pathname}?${newSearchParams.toString()}`, { ...options });
    }
  };

  return {
    pathname,
    searchParams,
    updateSearchParam,
  };
};

export default useSearchParams;
